"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState, useTransition } from "react";
import { clearCacheAction } from "@/actions/clear-cache";
import { useParams, useRouter } from "next/navigation";
import { createPortal } from "react-dom";
import { toast } from "sonner";
import { Button } from "./ui/button";
export const ClearCacheButton = () => {
  const $ = _c(13);
  const [currentId, setCurrentId] = useState();
  const [pending, start] = useTransition();
  const params = useParams();
  const router = useRouter();
  let t0;
  if ($[0] !== currentId || $[1] !== params?.projectId || $[2] !== params?.requestId || $[3] !== params?.taskId) {
    t0 = () => {
      let id = params?.projectId ?? params?.requestId ?? params?.taskId;
      if (id) {
        id = Array.isArray(id) ? id[0] : id;
        if (currentId === id) {
          return;
        }
        setCurrentId(id);
      } else {
        setCurrentId(undefined);
      }
    };
    $[0] = currentId;
    $[1] = params?.projectId;
    $[2] = params?.requestId;
    $[3] = params?.taskId;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== params) {
    t1 = [params];
    $[5] = params;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  useEffect(t0, t1);
  let t2;
  if ($[7] !== currentId || $[8] !== pending || $[9] !== router) {
    t2 = currentId && createPortal(<form className="absolute right-20 top-5 z-[9999999] lg:right-[16rem] lg:top-[1.6rem]" action={formData => start(async () => {
      await clearCacheAction(formData);
      toast.success("Cache cleared!");
      router.refresh();
    })}><input type="hidden" name="id" value={currentId} /><Button type="submit" variant="secondary" loading={pending}>Clear page cache</Button></form>, document.body);
    $[7] = currentId;
    $[8] = pending;
    $[9] = router;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== t2) {
    t3 = <>{t2}</>;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};